/* eslint-disable import/no-anonymous-default-export */
import { CHARGE_REFERRAL_SOURCE, HttpMethod } from '@/constants/utils'
import { createApiRequest } from '@/utils/api'

import type { IApplication } from './interfaces'

const readAllInReview = () =>
  createApiRequest({ method: HttpMethod.GET, path: '/applications/reviewed' })

const installApp = (id: string) =>
  createApiRequest({
    method: HttpMethod.PUT,
    path: `/applications/${id}/install`,
  })

const createAppCharge = (
  id: string,
  planId: string,
  chargeReferralSource?: string | null
) =>
  createApiRequest({
    method: HttpMethod.POST,
    path: `/applications/${id}/create-charge`,
    body: { plan_id: planId },
    ...(chargeReferralSource && {
      headers: {
        [CHARGE_REFERRAL_SOURCE.HEADER]: chargeReferralSource,
      },
    }),
  })

const getAppInfo = (id: string) =>
  createApiRequest<IApplication>({
    method: HttpMethod.GET,
    path: `/applications/${id}/published`,
  })

const getPublishedApps = () =>
  createApiRequest({
    method: HttpMethod.GET,
    path: '/applications/published',
    noauth: true,
  })

const getFeedbackSummary = (id: string) =>
  createApiRequest({
    method: HttpMethod.GET,
    path: `/feedback/rate/application/${id}`,
    noauth: true,
  })

const rateApp = (id: string, body: unknown) =>
  createApiRequest({
    method: HttpMethod.PUT,
    path: `/feedback/rate/application/${id}`,
    body,
  })

const getResources = (id: string) =>
  createApiRequest({
    method: HttpMethod.GET,
    path: `/applications/${id}/resources`,
    noauth: true,
  })

export default {
  readAllInReview,
  installApp,
  createAppCharge,
  getAppInfo,
  getResources,
  getPublishedApps,
  getFeedbackSummary,
  rateApp,
}
